import {
  RICH_TEXT_PART_TYPENAME,
  RICH_TEXT_TYPENAME
} from "~/constants/richText";
import { DTORichText } from "~/declarations/graphql/types";

export default function getNormalizedRichText(
  richText: DTORichText
): DTORichText {
  // It is possible that some texts were left unprocessed on the backend.
  if (!richText.parts.length && richText.text && richText.text.length) {
    return {
      __typename: RICH_TEXT_TYPENAME,
      text: richText.text,
      parts: [
        {
          __typename: RICH_TEXT_PART_TYPENAME.plain,
          text: richText.text
        }
      ]
    };
  }

  return richText;
}
